import { useContext } from "react";
import dateIntervalContext from "./dateIntervalContext.mjs";
import { parseISO, isBefore, isAfter } from "date-fns";
const numericCompare = (a, b) => Number(a) - Number(b);
function useDateIntervalContext() {
  let {
    startDate,
    endDate
  } = useContext(dateIntervalContext);
  startDate = startDate && parseISO(startDate.toString());
  endDate = endDate && parseISO(endDate.toString());
  function getDatesInInterval(dates) {
    dates = dates && dates.filter(Boolean);
    if (!(dates == null ? void 0 : dates.length)) {
      return [];
    }
    dates = dates.map(date => parseISO(date.toString()));
    if (startDate) {
      dates = dates.filter(date => !isBefore(date, startDate));
    }
    if (endDate) {
      dates = dates.filter(date => !isAfter(date, endDate));
    }
    dates.sort(numericCompare);
    return dates;
  }
  function getMostRelevantDate(dates) {
    dates = getDatesInInterval(dates);
    if (!(dates == null ? void 0 : dates.length)) {
      return;
    }
    let upcomingDates = dates.filter(date => !isBefore(date, /* @__PURE__ */new Date()));
    if (upcomingDates.length) {
      return upcomingDates[0];
    }
    let pastDates = dates.filter(date => !isAfter(date, /* @__PURE__ */new Date()));
    return pastDates[pastDates.length - 1];
  }
  return {
    startDate,
    endDate,
    getMostRelevantDate
  };
}
export { useDateIntervalContext as default };